<script>
  import { _ } from 'svelte-i18n'
  import { previews_weight_filter } from '../stores'
  let weights = [100, 200, 300, 400, 500, 600, 700, 800, 900]

  function handleClick(weight) {
    if (weight === $previews_weight_filter) {
      $previews_weight_filter = ""
    }
    else {
      $previews_weight_filter = weight
    }
  }
</script>

<ul>
  {#each weights as weight, index}
    <li on:click={()=>handleClick(weight)} class:active={$previews_weight_filter === weight}>
      {#if index === 0}
        {$_('buttons.thinnest')}
      {:else if index === weights.length-1 }
        {$_('buttons.thickest')}
      {:else}
        <span class="dot" style="width:{weight/100+2}px; height:{weight/100+2}px;">&nbsp;</span>
      {/if}
    </li>
  {/each}
</ul>

<style>
  ul {
    display: inline-block;
    vertical-align: top;
    background-color: var(--c-pill-bg);
    border-radius: 1.5rem;
  }
  li {
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    border-radius: 1.5rem;
    line-height: 2.6rem;
    cursor: pointer;
    transition: background-color var(--transition-props);
  }
  li:first-of-type,
  li:last-of-type {
    width: auto;
    padding: 0 1rem;
  }
  li .dot {
    display: inline-block;
    background-color: var(--c-text-faded);
    border-radius: 50%;
  }
  li:hover {
    color: var(--c-text-hover);
    background-color: var(--c-pill-bg-hover);
  }
  li:hover .dot {
    background-color: var(--c-text-hover);
  }
  li.active {
    background-color: var(--c-pill-bg-active);
    color: var(--c-text-on-fill-hover);
  }
  li.active .dot{
    background-color: var(--c-text-on-fill-hover);
  }
</style>